import { Button, IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import { AddOutlined, Search, FilterList, GetApp } from '@mui/icons-material';
import datastore from '../../store/hoa-datastore';
import Fab from '@mui/material/Fab';
import React, { useContext, useRef, useState } from "react";
import './hoa-filtering-comp.scss'

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ModalTemplate from '../../Container/modal';
import DatePickerForm from '../../Container/date-picker-form';

import ApplyAdvanceFilterComponent from './hoa-advance-filter-option';
import { GlobalContext } from '../../context/hoa-global-context';

import config from "../../hoa-config";
import LoadingComponent from '../../components/loading-component/loading-component';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import { DataDownloadConfirmationModal } from './data-download-confirmation-modal;';
import useExcelSheetDownload from '../../hooks/useExcelSheetDownload';
import SearchFilterComponent from './search-filter-component';

export default function FilteringComponenet(props: any) {

  const { title, subTitle, onAddClick, tagType, orgName, toggleUploadModal } = props;
  const { muncipality, updateMuncipalityData, property, updatePropertyData, hoa, updateHoaData, mail, updateMailData, email, updateEmailData, updateSelectedValues, document, updateDocumentData, requests, updateRequestsData } = useContext<any>(GlobalContext);
  const { hoaDataDownloadInExcel, propertyDataDownloadInExcel, mailDataDownloadInExcel, emailDataDownloadInExcel  } = useExcelSheetDownload()
  const buttonRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [options, setOptions] = useState(
    tagType === 'Municipality' ? muncipality.options :
    tagType === 'Property' ? property.options :
    tagType ===  'PropertyTask' ? property.options :
    tagType === 'Hoa' ? hoa.options :
    tagType === "Mail" ? mail.options :
    tagType === "Email" ? email.options :
    tagType === "Requests" ? requests.options :
    tagType === "Document" ? document.options :
    {});

  const [isModalOpen, setModalOpen] = useState(false);
  const [isDatePickerLoading, setDatePickerLoading] = useState(false);
  const [isDownloadingHoaList, setIsDownloadingHoaList]=useState(false);
  const [isDownloadingPropertyList, setIsDownloadingPropertyList]=useState(false)
  const [isDownloadedLoading, setDownLoadedLoading]=useState(false)
  
  const onChangeText = (event: any) => {
    if(event?.date) {
        setOptions({
          ...options,
          [event.date.key]: new Date(event.date.value).toLocaleString('en-US'),
        })
    } else if (event?.select) {
      setOptions({
        ...options,
        [event.select.key]: event.select.value
      })
    } else {
      setOptions({
        ...options,
        [event.target.name]: event.target.value
      })
    }
  }

  const onFilterKeyPress = (event: any) => {
		if (event.keyCode == 13) {
      updateData(options);
		}
  };

  const refetchMail = () => {
    updateData(options);
  }

  const onStatusChange = (event: any) => {
    var newOptions = {
      ...options,
      [event.target.name]: event.target.value
    }
    setOptions(newOptions);
    updateData(newOptions);
  }

  const onMoreFilterClick = (status: string) => {
    const values:any = tagType === 'PropertyTask' ? property.options : tagType === 'Municipality' ? muncipality.options : tagType === 'Property' ? property.options : tagType === 'Document' ? document.options : tagType === 'Mail' ? mail.options : tagType === 'Email' ? email.options : hoa.options;
    const prevValueChanged = !Object.keys(options).every((key)=> values[key] === options[key]);
    const clearAll = Object.keys(values).filter((key)=> {
        if(values[key]){
          return key;
        }
    });

    if (status === "Apply" && prevValueChanged) {

      updateData(options);

    }
    else if (status === "Clear") {

      if(clearAll.length !== 0) {
        const tmpValues: any = options;
        Object.keys(tmpValues).map((key) => {
          tmpValues[key] = null;
        });
        updateData(tmpValues);
      } else {
        setOptions({});
      }
    } else if ( status === 'Cancel') {

      const tmpValues: any = options;
      Object.keys(tmpValues).map((key) => {
        if(!values[key]) {
          tmpValues[key] = null;
        }
      });
      setOptions(tmpValues);
    }

    setAnchorEl(null);
  };

  const updateData = (options:any) => {
    if(new Date(options.from) > new Date(options.to)){
      alert(`Invalid date range!!!`)
      return;
    }
    if(tagType === 'Municipality') {
      updateMuncipalityData({
        ...muncipality,
        data: [],
        pageNumber: 1,
        options: options,
        isLastPage: false,
        fetchingFilteredData: true,
      });

    } else if (tagType === 'Property') {
      updatePropertyData({
        ...property,
        data: [],
        pageNumber: 1,
        options: options,
        isLastPage: false,
        fetchingFilteredData: true,
      })
    } else if (tagType === 'Hoa') {
      updateHoaData({
        ...property,
        data: [],
        pageNumber: 1,
        options: options,
        isLastPage: false,
        fetchingFilteredData: true,
      })
    } else if (tagType === 'Requests') {
      updateRequestsData({
        ...requests,
        data: [],
        pageNumber: 1,
        options: options,
        isLastPage: false,
        fetchingFilteredData: true,
      })
    } else if (tagType === 'Document') {
      updateDocumentData({
        ...document,
        data: [],
        pageNumber: 1,
        options: options,
        isLastPage: false,
        fetchingFilteredData: true,
      })
    } else if (tagType === 'Mail') {
      updateMailData({
        ...mail,
        data: [],
        pageNumber: 1,
        options: options,
        isLastPage: false,
        fetchingFilteredData: true,
      })
    } else if (tagType === 'Email') {
      updateEmailData({
        ...email,
        data: [],
        pageNumber: 1,
        options: options,
        isLastPage: false,
        fetchingFilteredData: true,
      })
    } else if(tagType === 'PropertyTask') {
      updatePropertyData({
        ...property,
        data: [],
        pageNumber: 1,
        options: options,
        isLastPage: false,
        fetchingFilteredData: true,
      })
    }
  }

  const handleDownloadListXlSheet =(tagType:any) =>{
    if(tagType === "Hoa"){
      hoaDataDownloadInExcel(hoa,setIsDownloadingHoaList)
    }
    if(tagType === "Property"){
      propertyDataDownloadInExcel(property, setIsDownloadingPropertyList)
    }
  }
  
  const handleFilterClick = () => {
    setAnchorEl(buttonRef.current);
  }

  const onDownloadYesClick = async () => {
    await mailDataDownloadInExcel(mail,setDownLoadedLoading,setModalOpen);
  };

    const onEmailDownloadYesClick = async () => {
    await emailDataDownloadInExcel(email,setDownLoadedLoading,setModalOpen);
  };
  

  if (window.innerWidth <= 768) {

    return (
      <>
        {responsiveFilterComponent(
          title,
          subTitle,
          anchorEl,
          setAnchorEl,
          onAddClick,
          options,
          onChangeText,
          onFilterKeyPress,
          onMoreFilterClick,
          tagType,
          onStatusChange
        )}
      </>
    );
  }

  return (
    <>
      <LoadingComponent loading={isDownloadedLoading} />
      {
        isModalOpen && (tagType =='Mail' || tagType == 'Email') && 
          <DataDownloadConfirmationModal
            tagType={tagType}
            isModalOpen={isModalOpen}
            setModalOpen={setModalOpen}
            isDownloadedLoading={isDownloadedLoading}
            onDownloadYesClick={onDownloadYesClick}
            onEmailDownloadYesClick={onEmailDownloadYesClick}
          />
      }
      <main className="filtering-main-container">
        <div className="filtering-sub-container">
          <div className="filtering-container left">
            <span className="filtering-left-container-title">{title}</span>
            <span className="filtering-left-container-subtitle">{subTitle}</span>
            <span className="filtering-left-container-subtitle">
              {tagType === 'Mail' ? `Total Count: ${mail.count ? mail.count : 'N/A'}` : 
                tagType === 'Email' ? `Total Count: ${email.count ? email.count : 'N/A'}` : 
                tagType === 'Municipality' ? `Total Count: ${muncipality.count ? muncipality.count : 'N/A'}` : 
                tagType === 'Property' ? `Total Count: ${property.count ? property.count : 'N/A'}` : 
                tagType === 'Hoa' ? `Total Count: ${hoa.count ? hoa.count : 'N/A'}` :
                tagType === 'Document' ? `Total Count: ${document.count ? document.count : 'N/A'}` : ''       
              }</span>
            <span className="filtering-left-container-subtitle">
              {
                tagType === 'Hoa' ? `Inactive HOAs (Last 3 Months): ${hoa.inactiveHoaCount !== null && hoa.inactiveHoaCount !== undefined ? hoa.inactiveHoaCount : 'N/A'}` :''       
              }
            </span>
          </div>
          <div className="filtering-container right">
          {(tagType !== 'Requests' && tagType !== 'DataFieldConfigurator') && 
                  <SearchFilterComponent 
                    tagType={tagType} 
                    options={options} 
                    onChangeText={onChangeText} 
                    onFilterKeyPress={onFilterKeyPress} 
                    handleFilterClick={handleFilterClick} 
                    buttonRef={buttonRef} 
                />
          } 
          
            {tagType === 'Property' || tagType === 'Hoa' ? 
              <div style={{display:"flex"}}>
            {datastore.isUserPermitted(tagType, '', 'download') && (
            <Tooltip
              style={{ alignSelf: "center" }}
              title={
              (tagType === "Hoa" && isDownloadingHoaList) ||
              (tagType === "Property" && isDownloadingPropertyList)
              ? 'Downloading'
              : `Download ${tagType === "Hoa" ? "HOAs" : "Properties"} List`
            }
            >
            <div>
              <IconButton
              disabled={
                (tagType === "Hoa" ? isDownloadingHoaList : isDownloadingPropertyList) || 
                Object.keys(options).length === 0
                }
                style={{ marginRight: '13px' }}
                onClick={() => {
                handleDownloadListXlSheet(tagType);
              }}
              >
              <GetApp 
                color={
                  ((tagType === "Hoa" && isDownloadingHoaList) || 
                  (tagType === "Property" && isDownloadingPropertyList)) ||
                  Object.keys(options).length === 0
                    ? "disabled"
                    : "primary"
                }
              />
              </IconButton>
              </div>
           </Tooltip>
            )}

                <div> 
                  {
                    datastore.isUserPermitted(tagType, 'add') && (
                      <Button
                        onClick={() => {
                          updateSelectedValues({});
                          tagType === 'Hoa' ?
                            onAddClick('selectMunicipality')
                            :
                            tagType === 'Property' ?
                              onAddClick('selectHoa')
                              :
                              onAddClick('add')
                        }}
                        startIcon={<AddOutlined />}
                        style={{ background: '#3576E5', color: 'white', width: '139px', height: '48px', borderRadius: '4px', textTransform: 'capitalize' }}
                        variant="contained">
                        <span className="add-new-btn">Add New</span>
                      </Button>
                    )
                  }
                </div>
               </div> 
            :tagType === 'PropertyTask' ? <span></span>
            :tagType === 'Mail' || tagType === 'Email' ? 
                <div style={{display: 'flex'}}>
                 {datastore.isUserPermitted(tagType, '', 'download') && (
              <Tooltip 
                title={`Download ${tagType} List`}
                >
                <IconButton
                  style={{ marginRight: '11px' }}
                  disabled={Object.keys(options).length === 0}
                  onClick={async () => setModalOpen(true)}
                >
                <GetApp 
                  color={Object.keys(options).length === 0 ? "disabled" : "primary"}
                />
              </IconButton>
            </Tooltip>
              )}


                  <div>
                  <FormControl>
                    <InputLabel id="demo-simple-select-helper-label">Status</InputLabel>
                    <Select
                      style={{ width: '139px', height: '51px', borderRadius: '4px' }}
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={options['status']}
                      name={'status'}
                      label="Status"
                      onChange={onStatusChange}
                    >
                      <MenuItem value="All">All</MenuItem>
                      {
                        config.mailMenuItem.map((item: any, index: number) => {
                          return (
                            <MenuItem key={index} value={item.value}><span style={{ height: 15, width: 15, marginRight: 5, borderRadius: 8, backgroundColor: item.menuItemColor }}></span> {item.value}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </FormControl>
                </div>
                </div>
            : (tagType === 'Requests' || tagType === 'Document') ?
                <div>
                  <FormControl>
                    <InputLabel id="demo-simple-select-helper-label">Status</InputLabel>
                    <Select
                      style={{ width: '139px', height: '51px', borderRadius: '4px' }}
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={options['status']}
                      name={'status'}
                      label="Status"
                      onChange={onStatusChange}
                    >
                      <MenuItem value="All">All</MenuItem>
                      {
                        config.documentMenuItem.map((item: any, index: number) => {
                          return (
                            <MenuItem key={index} value={item.value}><span style={{ height: 15, width: 15, marginRight: 5, borderRadius: 8, backgroundColor: item.menuItemColor }}></span> {item.value}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </FormControl>
                </div>
            : (tagType === 'DataFieldConfigurator') ?
                <div>
                  <FormControl>
                    <InputLabel id="demo-simple-select-helper-label">Organization</InputLabel>
                    <Select
                      style={{ width: '139px', height: '51px', borderRadius: '4px' }}
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={orgName}
                      name={'organization'}
                      label="organization"
                      onChange={onStatusChange}
                    >
                        <MenuItem value={orgName}>{orgName}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
            : (tagType !== 'Document' || tagType !== 'Email') && datastore.isUserPermitted(tagType, 'add') &&
              <Button
                onClick={() => {
                  updateSelectedValues({});
                  tagType === 'Hoa' ?
                    onAddClick('selectMunicipality')
                    :
                    tagType === 'Property' ?
                      onAddClick('selectHoa')
                      :
                      onAddClick('add')
                }}
                startIcon={<AddOutlined />}
                style={{ background: '#3576E5', color: 'white', width: '139px', height: '48px', borderRadius: '4px', textTransform: 'capitalize' }}
                variant="contained">
                <span className="add-new-btn">Add New</span>
              </Button>
            }
            {(tagType === 'Document' && datastore.isUserPermitted(tagType, 'add')) &&
              <Button
                onClick={toggleUploadModal}
                startIcon={<UploadOutlinedIcon />}
                style={{ background: '#3576E5', color: 'white', width: '139px', height: '48px', borderRadius: '4px', textTransform: 'capitalize', marginLeft: '15px' }}
                variant="contained">
                <span className="add-new-btn">Upload</span>
              </Button>
            }
          </div>
        </div>
      </main>
      <ApplyAdvanceFilterComponent
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        onChangeText={onChangeText}
        onMoreFilterClick={onMoreFilterClick}
        options={options}
        tagType={tagType}
      />
    </>
  )
}

const responsiveFilterComponent = (title: string, subTitle: string, anchorEl: any, setAnchorEl: any, onAddClick: any, options: any, onChangeText: any, onFilterKeyPress: any, onMoreFilterClick: any,tagType:any, onStatusChange: any) => {

  return (
    <>
    {(tagType !== 'Requests' && tagType !== 'DataFieldConfigurator') && (
      <ApplyAdvanceFilterComponent
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        onChangeText={onChangeText}
        onMoreFilterClick={onMoreFilterClick}
        options={options}
        tagType={tagType}
      />)}
      <main className="filtering-main-container">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: '5px' }}>
          <span style={{ fontSize: '18px' }} className="filtering-left-container-title">{title}</span>
          <span style={{ fontSize: '10px' }} className="filtering-left-container-subtitle">{subTitle}</span>
        </div>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0px 10px'}}>
        {
          (tagType === 'Requests' || tagType === 'Document') && (
            <div>
                  <FormControl>
                    <InputLabel id="demo-simple-select-helper-label">Status</InputLabel>
                    <Select
                      style={{ width: '139px', height: '48px', borderRadius: '4px' }}
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={options['status']}
                      name={'status'}
                      label="Status"
                      onChange={onStatusChange}
                    >
                      <MenuItem value="All">All</MenuItem>
                      {
                        config.documentMenuItem.map((item: any, index: number) => {
                          return (
                            <MenuItem key={index} value={item.value}><span style={{ height: 15, width: 15, marginRight: 5, borderRadius: 8, backgroundColor: item.menuItemColor }}></span> {item.value}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </FormControl>
                </div>
          )
        }
        {tagType !== 'Requests' && (
        <>
         {tagType !== 'Document' && (
          <Fab
            onClick={() =>
              tagType === "Hoa"
                ? onAddClick("selectMunicipality")
                : tagType === "Property"
                  ? onAddClick("selectHoa")
                  : onAddClick("add")
            }
            id="fab-icon-container"
            color="primary"
            aria-label="add"
          >
            <AddOutlined />
          </Fab>)}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px' }}>
            <TextField
              id='search-container-responsive'
              variant="outlined"
              placeholder={tagType === 'Municipality' ? 'Search by city' : tagType === 'Hoa' ? 'Search by HOA name' : 'Search by External Id'}
              value={(tagType === 'Municipality' ? options['city'] : tagType === 'Hoa' ?  options['name'] : options['externalId']) || ''}
              name={tagType === 'Municipality' ? 'city' : tagType === 'Hoa' ? 'name' : 'externalId'}
              onChange={onChangeText}
              onKeyDown={onFilterKeyPress}
              style={{ boxSizing: 'border-box' }}
              sx={{
                '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#E8E8E8',
                },
                '& .MuiInputBase-root.Mui-focused fieldset': {
                  borderColor: '#E8E8E8',
                },
                '& .MuiOutlinedInput-adornedEnd': {
                  paddingRight: '0px',
                },
              }}
              InputProps={{
                margin: 'none',
                className: 'searchInputClass',
                style: {
                  maxWidth: datastore.responsiveWidthOfMainDashboard - 16,
                  height: '40px',
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <Search style={{ color: '#9F9F9F' }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <Button
                    id="end-filtering-icon-title"
                    onClick={() => { setAnchorEl(document.getElementById('end-filtering-icon-title')) }}
                    style={{ minWidth: '98px', height: '100%', padding: '0px', textTransform: 'capitalize', fontSize: '12px' }}
                    startIcon={<FilterList style={{ color: '#9F9F9F' }} />}>
                    Filter
                  </Button>
                )
              }}
              type={'search'} />
          </div>
        </>)}
        </div>
      </main>
    </>
  )
}
